var _defs, _path, _path2, _path3, _g, _g2, _path4, _path5, _path6, _path7, _path8, _defs2, _path9, _path0, _g3, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLcLogoOptimiert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg104",
    viewBox: "0 0 322.41 321.83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title1"
  }, "Tux") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title1"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "tux_fx"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_belly_shadow"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop1",
    stopColor: "#000000",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop2",
    stopColor: "#000000",
    stopOpacity: 0.25,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_wing_tip_right_shadow"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop3",
    stopColor: "#110800",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop4",
    stopColor: "#a65a00",
    stopOpacity: 0.8,
    offset: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop5",
    stopColor: "#ff921e",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_eyeball"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop20",
    stopColor: "#fefefc",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop21",
    stopColor: "#fefefc",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop22",
    stopColor: "#d4d4d4",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_eyebrow"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop38",
    stopColor: "#646464",
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop39",
    stopColor: "#646464",
    stopOpacity: 0.58,
    offset: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop40",
    stopColor: "#646464",
    offset: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop41",
    stopColor: "#646464",
    stopOpacity: 0.26,
    offset: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop42",
    stopColor: "#646464",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_nares"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop57",
    stopColor: "#3a2903",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop58",
    stopColor: "#735208",
    offset: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop59",
    stopColor: "#ac8c04",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fill_belly_shadow_left",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(19,0,0,18,61.18,121.19)",
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_belly_shadow",
    xlinkHref: "#gradient_belly_shadow"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fill_belly_shadow_right",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(23.6,0,0,18,125.74,131.6)",
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_belly_shadow",
    xlinkHref: "#gradient_belly_shadow"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fill_belly_shadow_middle",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(9.35,0,0,10,94.21,127.47)",
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_belly_shadow",
    xlinkHref: "#gradient_belly_shadow"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill_foot_left_base",
    x1: 23.18,
    x2: 64.31,
    y1: 193.01,
    y2: 262.02,
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_foot_left_layer_1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop10",
    stopColor: "#b98309",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop11",
    stopColor: "#382605",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill_foot_left_glare",
    x1: 64.47,
    x2: 77.41,
    y1: 210.83,
    y2: 235.21,
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_foot_left_glare"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop12",
    stopColor: "#ebc40c",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop13",
    stopColor: "#ebc40c",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill_foot_right_shadow",
    x1: 146.93,
    x2: 150.2,
    y1: 211.96,
    y2: 235.73,
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_foot_right_shadow"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop14",
    stopColor: "#000000",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop15",
    stopColor: "#000000",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill_foot_right_base",
    x1: 151.5,
    x2: 192.94,
    y1: 253.02,
    y2: 185.84,
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_foot_right_layer_1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop16",
    stopColor: "#3e2a06",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop17",
    stopColor: "#ad780a",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill_foot_right_glare",
    x1: 162.81,
    x2: 161.59,
    y1: 180.67,
    y2: 191.64,
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_foot_right_glare"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop18",
    stopColor: "#f3cd0c",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop19",
    stopColor: "#f3cd0c",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fill_wing_tip_right_shadow_lower",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(18.99 5.0884 -5.342 19.937 169.71 194.53)",
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_wing_tip_right_shadow",
    xlinkHref: "#gradient_wing_tip_right_shadow"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fill_wing_tip_right_shadow_upper",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(19.722 -.83351 .62745 14.847 169.71 189.89)",
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_wing_tip_right_shadow",
    xlinkHref: "#gradient_wing_tip_right_shadow"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fill_wing_tip_right_glare_1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.3736 2.7713 -1.28 2.9438 184.65 176.62)",
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_wing_tip_right_glare_1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop6",
    stopColor: "#7c7c7c",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop7",
    stopColor: "#7c7c7c",
    stopOpacity: 0.33,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill_wing_tip_right_glare_2",
    x1: 165.69,
    x2: 168.27,
    y1: 173.58,
    y2: 173.47,
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_wing_tip_right_glare_2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop8",
    stopColor: "#7c7c7c",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop9",
    stopColor: "#7c7c7c",
    stopOpacity: 0.33,
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fill_eyeball_left",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(10.239 -.10723 .1642 15.679 86.49 51.41)",
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_eyeball",
    xlinkHref: "#gradient_eyeball"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill_pupil_left_glare",
    x1: 84.29,
    x2: 89.32,
    y1: 46.64,
    y2: 55.63,
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_pupil_left_glare"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop23",
    stopColor: "#757574",
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop24",
    stopColor: "#757574",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop25",
    stopColor: "#757574",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop26",
    stopColor: "#757574",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fill_eyelid_left",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.167 -1.0154 .93742 5.6933 84.89 43.74)",
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_eyelid_left"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop30",
    stopColor: "#c8c8c8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop31",
    stopColor: "#797978",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill_eyebrow_left",
    x1: 83.59,
    x2: 94.48,
    y1: 32.51,
    y2: 43.63,
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_eyebrow",
    xlinkHref: "#gradient_eyebrow"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fill_eyeball_right",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(13.633 -.42844 .49252 15.672 118.06 51.41)",
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_eyeball",
    xlinkHref: "#gradient_eyeball"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill_pupil_right_glare",
    x1: 117.87,
    x2: 123.66,
    y1: 47.25,
    y2: 54.11,
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_pupil_right_glare_2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop27",
    stopColor: "#949494",
    stopOpacity: 0.39,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop28",
    stopColor: "#949494",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop29",
    stopColor: "#949494",
    stopOpacity: 0.39,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill_eyelid_right",
    x1: 112.9,
    x2: 131.32,
    y1: 36.23,
    y2: 47.01,
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_eyelid_right"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop32",
    stopColor: "#747474",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop33",
    stopColor: "#8c8c8c",
    offset: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop34",
    stopColor: "#a4a4a4",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop35",
    stopColor: "#d4d4d4",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop36",
    stopColor: "#d4d4d4",
    offset: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop37",
    stopColor: "#7c7c7c",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill_eyebrow_right",
    x1: 119.16,
    x2: 131.42,
    y1: 31.56,
    y2: 43.14,
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_eyebrow",
    xlinkHref: "#gradient_eyebrow"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fill_beak_base",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(9.2552 -6.7243 6.1012 8.3976 97.64 60.12)",
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_beak_base"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop43",
    stopColor: "#020204",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop44",
    stopColor: "#020204",
    offset: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop45",
    stopColor: "#5c5c5c",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fill_mandible_lower_base",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(25.101 -10.346 7.267 17.631 109.77 70.61)",
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_mandible_lower"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop46",
    stopColor: "#d2940a",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop47",
    stopColor: "#d89c08",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop48",
    stopColor: "#b67e07",
    offset: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop49",
    stopColor: "#946106",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill_mandible_upper_base",
    x1: 78.09,
    x2: 126.77,
    y1: 69.26,
    y2: 68.88,
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_mandible_upper"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop50",
    stopColor: "#ad780a",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop51",
    stopColor: "#d89e08",
    offset: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop52",
    stopColor: "#edb80b",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop53",
    stopColor: "#ebc80d",
    offset: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop54",
    stopColor: "#f5d838",
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop55",
    stopColor: "#f6d811",
    offset: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop56",
    stopColor: "#f5cd31",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fill_naris_left",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.32,0,0,1.42,92.11,59.88)",
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_nares",
    xlinkHref: "#gradient_nares"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fill_naris_right",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.78,0,0,1.62,104.65,59.7)",
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_nares",
    xlinkHref: "#gradient_nares"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill_beak_corner",
    x1: 126.74,
    x2: 126.74,
    y1: 67.49,
    y2: 71.09,
    gradientUnits: "userSpaceOnUse",
    href: "#gradient_beak_corner"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop60",
    stopColor: "#f5ce2d",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop61",
    stopColor: "#d79b08",
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_belly_shadow_left",
    x: -0.049919,
    y: -0.045849,
    width: 1.0998,
    height: 1.0917
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur61",
    stdDeviation: "0.64 0.55"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_belly_shadow_right",
    x: -0.050747,
    y: -0.073203,
    width: 1.1015,
    height: 1.1464
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur62",
    stdDeviation: 0.98
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_belly_shadow_middle",
    x: -0.087319,
    y: -0.081682,
    width: 1.1746,
    height: 1.1634
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur63",
    stdDeviation: 0.68
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_belly_shadow_lower",
    x: -0.81954,
    y: -0.057993,
    width: 2.6391,
    height: 1.116
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur64",
    stdDeviation: 1.25
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_belly_glare",
    x: -0.49197,
    y: -0.59291,
    width: 1.9839,
    height: 2.1858
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur65",
    stdDeviation: "1.78 2.19"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_head_glare",
    x: -0.29258,
    y: -0.30859,
    width: 1.5852,
    height: 1.6172
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur66",
    stdDeviation: 1.73
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_neck_glare",
    x: -0.17841,
    y: -0.16017,
    width: 1.3568,
    height: 1.3203
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur67",
    stdDeviation: 0.78
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_wing_left_glare",
    x: -0.10145,
    y: -0.042862,
    width: 1.2029,
    height: 1.0857
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur68",
    stdDeviation: 0.98
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_wing_right_glare",
    x: -0.1179,
    y: -0.040212,
    width: 1.2358,
    height: 1.0804
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur69",
    stdDeviation: "1.19 1.17"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_foot_left_layer_1",
    x: -0.10746,
    y: -0.10845,
    width: 1.2149,
    height: 1.2169
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur70",
    stdDeviation: 3.38
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_foot_left_layer_2",
    x: -0.075378,
    y: -0.069657,
    width: 1.1508,
    height: 1.1393
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur71",
    stdDeviation: "2.1 2.06"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_foot_left_glare",
    x: -0.033862,
    y: -0.018668,
    width: 1.0677,
    height: 1.0373
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur72",
    stdDeviation: 0.32
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_foot_right_shadow",
    x: -0.076044,
    y: -0.068073,
    width: 1.1521,
    height: 1.1361
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur73",
    stdDeviation: "1.95 1.9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_foot_right_layer_1",
    x: -0.14509,
    y: -0.14307,
    width: 1.2902,
    height: 1.2861
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur74",
    stdDeviation: 4.12
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_foot_right_layer_2",
    x: -0.11511,
    y: -0.12498,
    width: 1.2302,
    height: 1.25
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur75",
    stdDeviation: "3.12 3.37"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_foot_right_glare",
    x: -0.020751,
    y: -0.12827,
    width: 1.0415,
    height: 1.2565
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur76",
    stdDeviation: 0.41
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_wing_tip_right_shadow_lower",
    x: -0.20044,
    y: -0.23395,
    width: 1.4009,
    height: 1.4679
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur77",
    stdDeviation: 2.45
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_wing_tip_right_shadow_upper",
    x: -0.091629,
    y: -0.10698,
    width: 1.1833,
    height: 1.214
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur78",
    stdDeviation: "1.12 0.81"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_wing_tip_right_glare",
    x: -0.070171,
    y: -0.14998,
    width: 1.1403,
    height: 1.3
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur79",
    stdDeviation: 0.88
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_pupil_left_glare",
    x: -0.23333,
    y: -0.14544,
    width: 1.4667,
    height: 1.2909
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur80",
    stdDeviation: 0.44
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_eyebrow_left",
    x: -0.023848,
    y: -0.026523,
    width: 1.0477,
    height: 1.053
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur81",
    stdDeviation: 0.12
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_pupil_right_glare",
    x: -0.17959,
    y: -0.18232,
    width: 1.3592,
    height: 1.3646
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur82",
    stdDeviation: 0.45
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_eyebrow_right",
    x: -0.023601,
    y: -0.025574,
    width: 1.0472,
    height: 1.0511
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur83",
    stdDeviation: 0.13
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_beak_shadow_lower",
    x: -0.076202,
    y: -0.12888,
    width: 1.1524,
    height: 1.2578
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur84",
    stdDeviation: 1.75
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_beak_shadow_upper",
    x: -0.036392,
    y: -0.074089,
    width: 1.0728,
    height: 1.1482
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur85",
    stdDeviation: "0.8 0.74"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_mandible_lower_glare",
    x: -0.15437,
    y: -0.21067,
    width: 1.3087,
    height: 1.4213
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur86",
    stdDeviation: 0.77
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_mandible_upper_shadow",
    x: -0.034221,
    y: -0.078979,
    width: 1.0684,
    height: 1.158
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur87",
    stdDeviation: 0.65
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_mandible_upper_glare",
    x: -0.16065,
    y: -0.13004,
    width: 1.3213,
    height: 1.2601
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur88",
    stdDeviation: 0.73
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_naris_left",
    x: -0.12244,
    y: -0.11124,
    width: 1.2449,
    height: 1.2225
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur89",
    stdDeviation: 0.1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_naris_right",
    x: -0.049122,
    y: -0.093498,
    width: 1.0982,
    height: 1.187
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur90",
    stdDeviation: 0.1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur_beak_corner",
    x: -0.11091,
    y: -0.09064,
    width: 1.2218,
    height: 1.1813
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur91",
    stdDeviation: 0.23
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_body"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use91",
    href: "#body_base",
    xlinkHref: "#body_base"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_wing_left"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use92",
    href: "#wing_left_base",
    xlinkHref: "#wing_left_base"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_wing_right"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use93",
    href: "#wing_right_base",
    xlinkHref: "#wing_right_base"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_foot_left"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use94",
    href: "#foot_left_base",
    xlinkHref: "#foot_left_base"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_foot_right"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use95",
    href: "#foot_right_base",
    xlinkHref: "#foot_right_base"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_wing_tip_right"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use96",
    href: "#wing_tip_right_base",
    xlinkHref: "#wing_tip_right_base"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_eye_left"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use97",
    href: "#eyeball_left",
    xlinkHref: "#eyeball_left"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_pupil_left"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use98",
    href: "#pupil_left_base",
    xlinkHref: "#pupil_left_base"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_eye_right"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use99",
    href: "#eyeball_right",
    xlinkHref: "#eyeball_right"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_pupil_right"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use100",
    href: "#pupil_right_base",
    xlinkHref: "#pupil_right_base"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_mandible_lower"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use101",
    href: "#mandible_lower_base",
    xlinkHref: "#mandible_lower_base"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_mandible_upper"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use102",
    href: "#mandible_upper_base",
    xlinkHref: "#mandible_upper_base"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_beak"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use103",
    href: "#mandible_lower_base",
    xlinkHref: "#mandible_lower_base"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use104",
    href: "#mandible_upper_base",
    xlinkHref: "#mandible_upper_base"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    id: "path106",
    transform: "matrix(-.63736 .77057 .76933 .63885 0 0)",
    cx: 20.812,
    cy: 226.78,
    rx: 158.54,
    ry: 161.73,
    style: {
      fill: "none",
      opacity: 0.86526,
      strokeLinejoin: "bevel",
      strokeWidth: 1.836,
      stroke: "#001582"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "tux",
    transform: "translate(53.632 16.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "body_base",
    d: "m106.95 0c-6 0-12.02 1.18-17.46 4.12-5.78 3.11-10.52 8.09-13.43 13.97-2.92 5.88-4.06 12.16-4.24 19.08-.33 13.14.3 26.92 1.29 39.41.26 3.8.74 6.02.25 9.93-1.62 8.3-8.88 13.88-12.76 21.17-4.27 8.04-6.07 17.13-9.29 25.65-2.95 7.79-7.09 15.1-9.88 22.95-3.91 10.97-5.08 23.03-2.5 34.39 1.97 8.66 6.08 16.78 11.62 23.73-.8 1.44-1.58 2.91-2.4 4.34-2.57 4.43-5.71 8.64-7.17 13.55-.73 2.45-1.02 5.07-.55 7.59s1.75 4.93 3.75 6.53c1.31 1.04 2.9 1.72 4.53 2.1 1.63.37 3.32.46 5 .43 6.37-.14 12.55-2.07 18.71-3.69 3.66-.96 7.34-1.81 11.03-2.58 13.14-2.69 27.8-1.61 39.99.15 4.13.63 8.23 1.44 12.29 2.43 6.36 1.54 12.69 3.5 19.23 3.69 1.72.05 3.46-.03 5.14-.4 1.68-.38 3.31-1.06 4.65-2.13 2.01-1.6 3.29-4.02 3.76-6.54s.18-5.15-.56-7.61c-1.48-4.92-4.65-9.11-7.27-13.52-1.04-1.75-2-3.53-3.03-5.28 7.9-8.87 14.26-19.13 17.94-30.4 4.01-12.3 4.75-25.55 3.06-38.38s-5.76-25.27-11.11-37.05c-6.72-14.76-12.37-20.1-16.47-33.07-4.42-14.02-.77-30.61-4.06-43.32-1.17-4.32-3.04-8.45-5.45-12.23-2.82-4.43-6.4-8.39-10.65-11.47-6.78-4.92-15.3-7.54-23.96-7.54z",
    fill: "#020204"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "belly",
    d: "m83.13 74c-.9 1.13-1.48 2.49-1.84 3.89-.35 1.4-.48 2.85-.54 4.3-.11 2.89.07 5.83-.7 8.62-.82 2.98-2.65 5.57-4.44 8.08-3.11 4.36-6.25 8.84-7.78 13.97-.93 3.1-1.24 6.39-.91 9.62-3.47 5.1-6.48 10.53-8.98 16.18-3.78 8.57-6.37 17.69-7.28 27.01-1.12 11.41.34 23.15 4.85 33.69 3.25 7.63 8.11 14.6 14.38 20.04 3.18 2.76 6.72 5.11 10.5 6.97 13.11 6.45 29.31 6.46 42.2-.41 6.74-3.59 12.43-8.84 17.91-14.15 3.3-3.2 6.59-6.48 9.11-10.32 4.85-7.41 6.54-16.41 7.59-25.2 1.83-15.36 1.89-31.6-4.85-45.53-2.32-4.8-5.41-9.22-9.12-13.05-.98-6.7-2.93-13.27-5.76-19.42-2.05-4.45-4.54-8.68-6.44-13.18-.78-1.85-1.46-3.75-2.32-5.56-.87-1.81-1.93-3.55-3.39-4.94-1.48-1.42-3.33-2.43-5.28-3.07-1.95-.65-4.01-.94-6.06-1.04-4.11-.21-8.22.33-12.33.16-3.27-.13-6.53-.7-9.8-.51-1.63.1-3.26.39-4.78 1.01-1.52.61-2.92 1.56-3.94 2.84z",
    fill: "#fdfdfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "body_self_shadows"
  }, /*#__PURE__*/React.createElement("path", {
    id: "belly_shadow_left",
    d: "m68.67 115.18c.87 1.31-.55 5.84 19.86 2.94 0 0-3.59.39-7.12 1.21-5.49 1.84-10.27 3.89-13.97 6.61-3.65 2.7-6.33 6.21-9.68 9.22 0 0 5.43-9.92 6.78-12.91 1.36-2.99-.22-2.85.85-7.25s3.69-8.63 3.69-8.63-2.14 6.22-.41 8.81z",
    clipPath: "url(#clip_body)",
    fill: "url(#fill_belly_shadow_left)",
    filter: "url(#blur_belly_shadow_left)",
    opacity: 0.25,
    style: {
      fill: "url(#fill_belly_shadow_left)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "belly_shadow_right",
    d: "m134.28 113.99c-4.16 2.9-6.6 2.56-11.64 3.12-5.05.57-18.7.36-18.7.36s1.97-.03 6.36.78c4.38.82 13.31 1.6 18.34 3.51 5.04 1.92 6.87 2.47 9.93 4.4 4.35 2.75 7.55 7.06 11.71 10.08 0 0 .2-4-1.48-6.99s-6.2-7.7-7.53-12.1c-1.32-4.4-1.96-13.04-1.96-13.04s-.88 6.99-5.03 9.88z",
    clipPath: "url(#clip_body)",
    fill: "url(#fill_belly_shadow_right)",
    filter: "url(#blur_belly_shadow_right)",
    opacity: 0.42,
    style: {
      fill: "url(#fill_belly_shadow_right)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "belly_shadow_middle",
    d: "m95.17 107.81c-.16 1.25-.36 2.5-.6 3.74-.12.61-.26 1.22-.48 1.8-.23.58-.56 1.14-1.02 1.55-.41.37-.9.62-1.4.85-1.94.88-4.01 1.47-6.12 1.74.84.06 1.68.14 2.53.23.53.06 1.06.12 1.57.25.52.14 1.03.34 1.46.65.47.35.84.82 1.12 1.34.55 1.02.73 2.2.83 3.37.13 1.48.14 2.98.03 4.46.1-.99.31-1.98.62-2.92.57-1.72 1.47-3.32 2.69-4.65.49-.52 1.02-1.01 1.6-1.42 1.79-1.26 4.07-1.81 6.24-1.51-2.21.09-4.44-.6-6.2-1.93-.9-.68-1.68-1.52-2.22-2.5-.84-1.52-1.08-3.37-.65-5.05z",
    clipPath: "url(#clip_body)",
    fill: "url(#fill_belly_shadow_middle)",
    filter: "url(#blur_belly_shadow_middle)",
    opacity: 0.2,
    style: {
      fill: "url(#fill_belly_shadow_middle)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "belly_shadow_lower",
    d: "m89.85 137.14c-1.06 4.03-1.79 8.15-2.17 12.31-.55 5.87-.42 11.78-.74 17.67-.26 4.99-.85 10.04.02 14.97.41 2.35 1.15 4.64 2.2 6.78.16-.82.29-1.64.36-2.47.37-4-.3-8.01-.53-12.01-.4-7.02.57-14.04.97-21.06.3-5.39.27-10.8-.11-16.19z",
    clipPath: "url(#clip_body)",
    fill: "#000000",
    filter: "url(#blur_belly_shadow_lower)",
    opacity: 0.11
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "body_glare"
  }, /*#__PURE__*/React.createElement("path", {
    id: "belly_glare",
    d: "m160.08 131.23c1.03-.16 7.34 5.21 6.48 7.21-.86 1.99-2.49.79-3.65.8-1.16.02-4.33 1.46-4.86.55-.54-.91 1.4-3.03 2.41-4.81.82-1.43-1.4-3.59-.38-3.75z",
    clipPath: "url(#clip_body)",
    fill: "#7c7c7c",
    filter: "url(#blur_belly_glare)",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "head_glare",
    d: "m121.52 11.12c-2.21 1.56-1.25 3.51-.3 5.46.95 1.96-2.09 7.59-2.12 7.83s5.98-2.85 7.62-4.87c1.94-2.37 6.83 3.22 6.56 2.37.01-1.52-9.55-12.34-11.76-10.79z",
    clipPath: "url(#clip_body)",
    fill: "#7c7c7c",
    filter: "url(#blur_head_glare)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "neck_glare",
    d: "m138.27 76.63c-1.86 1.7.88 4.25 2.17 7.24.81 1.86 3.04 4.49 5.2 4.07 1.63-.32 2.63-2.66 2.48-4.3-.3-3.18-2.98-3.93-4.93-5.02-1.54-.86-3.61-3.18-4.92-1.99z",
    clipPath: "url(#clip_body)",
    fill: "#838384",
    filter: "url(#blur_neck_glare)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "wings"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wing_left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "wing_left_base",
    d: "m63.98 100.91c-6.1 6.92-12.37 13.63-15.81 21.12-1.71 3.8-2.51 7.93-3.68 11.93-1.32 4.54-3.12 8.94-5.14 13.22-1.87 3.95-3.93 7.81-5.98 11.66-1.5 2.81-3.02 5.67-3.54 8.81-.41 2.48-.18 5.04.46 7.47.63 2.43 1.64 4.75 2.79 6.98 4.88 9.55 12.21 17.77 20.89 24.07 3.94 2.85 8.15 5.32 12.58 7.35 2.4 1.09 4.92 2.07 7.56 2.11 1.32.03 2.65-.19 3.86-.72 1.2-.53 2.28-1.38 3-2.49.88-1.36 1.18-3.05 1-4.66s-.81-3.15-1.65-4.53c-2.06-3.38-5.31-5.83-8.44-8.25-6.76-5.23-13.29-10.76-19.55-16.58-1.76-1.65-3.53-3.34-4.76-5.42-1.2-2.02-1.85-4.32-2.29-6.63-1.21-6.33-.9-12.99 1.25-19.07.85-2.38 1.96-4.65 3.04-6.93 1.86-3.95 3.62-7.98 6.07-11.6 3.05-4.51 7.13-8.33 9.61-13.17 2.1-4.09 2.95-8.68 3.76-13.2.64-3.54 1.85-7 2.47-10.54-1.21 2.3-5.11 6.07-7.5 9.07z",
    fill: "#020204"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wing_left_glare",
    d: "m56.96 126.1c-2 1.84-3.73 3.97-5.13 6.31-2.3 3.84-3.65 8.16-5.33 12.31-1.24 3.09-2.69 6.2-2.86 9.53-.09 1.71.16 3.42.22 5.13s-.1 3.49-.94 4.98c-.7 1.25-1.87 2.23-3.22 2.71 1.83.61 3.45 1.79 4.6 3.33.96 1.3 1.58 2.81 2.41 4.18.68 1.12 1.51 2.16 2.54 2.97 1.02.82 2.25 1.4 3.54 1.56 1.79.23 3.65-.36 4.97-1.58-1.66-15.55-.14-31.42 4.44-46.37.29-.94.59-1.89.67-2.87.07-.99-.12-2.03-.72-2.81-.31-.42-.74-.75-1.23-.96-.48-.2-1.02-.28-1.54-.21-.52.06-1.03.26-1.45.57-.42.32-.76.74-.97 1.22z",
    clipPath: "url(#clip_wing_left)",
    fill: "#7c7c7c",
    filter: "url(#blur_wing_left_glare)",
    opacity: 0.95
  })), /*#__PURE__*/React.createElement("g", {
    id: "wing_right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "wing_right_base",
    d: "m162.76 127.12c5.24 4.22 8.57 10.59 9.6 17.24.8 5.18.28 10.51-.89 15.62-1.17 5.12-2.97 10.06-4.77 15-.71 1.96-1.43 3.95-1.71 6.02-.29 2.08-.11 4.27.89 6.11 1.15 2.11 3.29 3.56 5.59 4.24 2.27.68 4.72.66 7.02.09s6.17-1.31 8.04-2.77c4.75-3.69 5.88-10.1 7.01-15.72 1.17-5.87.6-12.02-.43-17.95-1.41-8.09-3.78-15.99-6.79-23.62-2.22-5.62-5.06-10.98-8.44-15.96-3.32-4.89-8.02-8.7-11.5-13.48-1.21-1.66-2.66-3.38-3.84-5.06-2.56-3.62-1.98-2.94-3.57-5.29-1.15-1.7-2.97-2.28-4.88-3.02-1.92-.74-4.06-.96-6.04-.41-2.6.73-4.73 2.79-5.86 5.24-1.13 2.46-1.33 5.28-.89 7.95.57 3.44 2.14 6.64 3.92 9.64 2 3.39 4.32 6.66 7.35 9.18 3.16 2.63 6.98 4.37 10.19 6.95z",
    fill: "#020204"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wing_right_glare",
    d: "m150.42 118.99c.42.4.86.81 1.31 1.19 3.22 2.63 4.93 5.58 8.2 8.16 5.34 4.22 10.75 11.5 11.8 18.15.82 5.19-.26 8.01-1.58 14.12-1.32 6.12-5.06 14.78-7.09 20.68-.8 2.35 1.64 1.38 1.32 3.86-.16 1.22-.18 2.45-.03 3.67.02-.23.03-.48.06-.71.39-3.38 1.42-6.63 2.55-9.82 2.17-6.13 4.66-12.15 6.38-18.45 1.72-6.29 1.53-10.82.63-16.23-1.13-6.81-5.09-13.09-10.69-17.24-3.97-2.93-8.64-4.81-12.86-7.38z",
    clipPath: "url(#clip_wing_right)",
    fill: "#838384",
    filter: "url(#blur_wing_right_glare)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "feet"
  }, /*#__PURE__*/React.createElement("g", {
    id: "foot_left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "foot_left_base",
    d: "m34.98 175.33c1.38-.57 2.93-.68 4.39-.41 1.47.27 2.86.91 4.09 1.74 2.47 1.68 4.3 4.12 6.05 6.54 4.03 5.54 7.9 11.2 11.42 17.08 2.85 4.78 5.46 9.71 8.76 14.18 2.15 2.93 4.57 5.64 6.73 8.55 2.16 2.92 4.07 6.08 5.03 9.58 1.25 4.55.76 9.56-1.4 13.75-1.52 2.95-3.86 5.48-6.7 7.19s-5.83 2.47-9.15 2.47c-5.27 0-10.42-2.83-15.32-4.78-9.98-3.98-20.82-5.22-31.11-8.32-3.16-.95-6.27-2.08-9.45-2.95-1.42-.39-2.85-.73-4.19-1.34-1.34-.6-2.59-1.51-3.33-2.77-.57-.98-.8-2.13-.8-3.26 0-1.14.28-2.26.67-3.32.77-2.13 2.02-4.06 2.86-6.17 1.37-3.44 1.62-7.23 1.43-10.93-.18-3.69-.78-7.36-1.03-11.05-.12-1.65-.16-3.32.16-4.95.31-1.62 1.01-3.21 2.2-4.35 1.1-1.06 2.55-1.69 4.05-2 1.49-.31 3.03-.32 4.55-.29s3.05.12 4.57-.01c1.52-.12 3.05-.46 4.37-1.22 1.26-.72 2.29-1.79 3.14-2.96s1.54-2.45 2.25-3.72c.7-1.26 1.43-2.52 2.36-3.64.92-1.12 2.06-2.09 3.4-2.64z",
    fill: "url(#fill_foot_left_base)",
    style: {
      fill: "url(#fill_foot_left_base)"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "foot_left_layer_1",
    d: "m37.16 177.7c1.25-.5 2.67-.56 3.98-.26 1.32.3 2.55.94 3.61 1.77 2.14 1.65 3.62 3.97 5.05 6.26 3.42 5.54 6.76 11.15 9.92 16.86 2.4 4.31 4.68 8.7 7.62 12.65 1.95 2.62 4.18 5.03 6.17 7.62s3.76 5.41 4.64 8.56c1.14 4.05.68 8.54-1.28 12.26-1.42 2.68-3.58 4.96-6.2 6.48-2.61 1.52-5.67 2.28-8.69 2.14-4.82-.22-9.23-2.63-13.77-4.26-8.71-3.16-18.14-3.59-27.08-6.05-3.2-.87-6.32-2.03-9.53-2.84-1.43-.36-2.88-.66-4.23-1.23s-2.62-1.45-3.36-2.72c-.54-.95-.76-2.06-.73-3.15.04-1.09.31-2.17.7-3.19.78-2.04 2-3.88 2.78-5.92 1.19-3.08 1.34-6.47 1.12-9.76s-.8-6.56-1-9.85c-.08-1.48-.1-2.97.2-4.41.3-1.45.93-2.85 1.98-3.89 1.14-1.13 2.7-1.74 4.29-1.99 1.58-.24 3.19-.13 4.78.01 1.6.14 3.2.32 4.8.23 1.6-.1 3.22-.49 4.54-1.39 1.2-.81 2.1-2 2.79-3.27s1.18-2.64 1.71-3.98c.52-1.35 1.09-2.69 1.91-3.89.82-1.19 1.93-2.24 3.28-2.79z",
    clipPath: "url(#clip_foot_left)",
    fill: "#d99a03",
    filter: "url(#blur_foot_left_layer_1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "foot_left_layer_2",
    d: "m35.99 174.57c1.22-.6 2.65-.72 3.98-.45s2.57.92 3.62 1.77c2.09 1.7 3.43 4.13 4.67 6.51 2.84 5.46 5.5 11.04 8.9 16.19 2.48 3.73 5.33 7.2 7.83 10.92 3.39 5.03 6.15 10.57 7.29 16.5.76 4 .74 8.31-1.18 11.9-1.27 2.37-3.32 4.31-5.75 5.52-2.42 1.22-5.21 1.71-7.92 1.47-4.27-.37-8.14-2.47-12.16-3.94-7.13-2.59-14.84-3.22-22.18-5.18-3.09-.82-6.13-1.89-9.26-2.54-1.39-.29-2.8-.5-4.12-1s-2.57-1.33-3.25-2.55c-.47-.86-.63-1.86-.56-2.84.07-.97.36-1.92.74-2.83.77-1.8 1.9-3.46 2.49-5.32.88-2.75.52-5.72-.14-8.53-.65-2.8-1.6-5.55-1.89-8.41-.13-1.27-.13-2.57.17-3.82.29-1.25.88-2.45 1.81-3.34 1.2-1.15 2.88-1.73 4.56-1.89 1.67-.16 3.35.06 5.01.3s3.34.5 5.01.42c1.68-.07 3.39-.51 4.7-1.54 1.3-1.02 2.12-2.53 2.59-4.09.47-1.57.62-3.2.81-4.82s.43-3.26 1.06-4.77 1.69-2.9 3.17-3.64z",
    clipPath: "url(#clip_foot_left)",
    fill: "#f5bd0c",
    filter: "url(#blur_foot_left_layer_2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "foot_left_glare",
    d: "m51.2 188.21c2.25 4.06 3.62 8.72 5.85 12.82 2.05 3.77 4.38 7.65 6.46 11.12.93 1.55 3.09 3.93 5.27 7.62 1.98 3.34 3.98 8.01 5.1 9.58-.64-1.84-1.96-6.77-3.54-10.28-1.47-3.28-3.19-5.15-4.24-6.92-2.08-3.47-4.33-6.6-6.47-9.91-2.95-4.57-5.2-9.68-8.43-14.03z",
    clipPath: "url(#clip_foot_left)",
    fill: "url(#fill_foot_left_glare)",
    filter: "url(#blur_foot_left_glare)",
    style: {
      fill: "url(#fill_foot_left_glare)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "foot_right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "foot_right_shadow",
    d: "m198.7 215.61c-.4 1.33-1.02 2.62-1.81 3.8-1.75 2.59-4.3 4.55-6.84 6.35-4.33 3.07-8.85 5.89-12.89 9.38-2.7 2.34-5.17 4.97-7.45 7.73-1.95 2.36-3.79 4.84-6.02 6.94-2.25 2.12-4.89 3.84-7.74 4.77-3.47 1.13-7.13 1.08-10.47.22-2.34-.6-4.63-1.64-6.08-3.53s-1.92-4.44-2.09-6.94c-.3-4.42.23-8.93.71-13.42.4-3.73.77-7.46.92-11.18.27-6.77-.18-13.47-1.09-20.05-.16-1.11-.32-2.22-.23-3.35.09-1.14.47-2.32 1.27-3.2.74-.81 1.77-1.29 2.79-1.52 1.02-.24 2.06-.25 3.09-.28 2.43-.06 4.86-.21 7.25.01 1.51.13 2.99.41 4.49.55 2.51.24 5.12.12 7.64-.62 2.71-.8 5.29-2.29 8.05-2.7 1.13-.17 2.26-.15 3.36.01 1.12.15 2.24.46 3.1 1.15.66.52 1.14 1.23 1.51 1.99.56 1.14.9 2.39 1.1 3.68.17 1.14.24 2.31.53 3.41.48 1.81 1.58 3.35 2.89 4.6 1.32 1.25 2.85 2.24 4.39 3.22 1.53.97 3.07 1.93 4.7 2.73.77.38 1.56.72 2.29 1.15.74.44 1.42.97 1.91 1.67.66.95.92 2.2.72 3.43z",
    clipPath: "url(#clip_body)",
    fill: "url(#fill_foot_right_shadow)",
    filter: "url(#blur_foot_right_shadow)",
    opacity: 0.2,
    style: {
      fill: "url(#fill_foot_right_shadow)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "foot_right_base",
    d: "m213.47 222.92c-2.26 2.68-5.4 4.45-8.53 6.05-5.33 2.71-10.86 5.1-15.87 8.37-3.36 2.19-6.46 4.76-9.36 7.53-2.48 2.37-4.83 4.9-7.61 6.91-2.81 2.03-6.05 3.5-9.48 4.01-.95.14-1.9.21-2.86.21-3.24 0-6.48-.78-9.46-2.08-2.7-1.17-5.3-2.86-6.86-5.36-1.56-2.52-1.92-5.59-1.92-8.56-.01-5.23.96-10.41 1.87-15.57.76-4.29 1.48-8.58 1.95-12.91.85-7.86.84-15.81.28-23.71-.1-1.32-.21-2.65-.01-3.96s.74-2.62 1.74-3.48c.93-.8 2.17-1.16 3.4-1.22 1.22-.07 2.44.12 3.65.3 2.85.42 5.73.74 8.52 1.48 1.76.46 3.48 1.08 5.23 1.56 2.94.79 6.01 1.17 9.02.82 3.25-.38 6.41-1.6 9.68-1.52 1.34.03 2.67.28 3.95.69 1.3.41 2.59 1 3.55 1.98.73.74 1.24 1.67 1.62 2.64.57 1.44.88 2.98 1.01 4.52.11 1.37.09 2.76.35 4.11.43 2.21 1.6 4.24 3.04 5.97 1.45 1.74 3.18 3.21 4.91 4.66s3.46 2.89 5.32 4.16c.87.6 1.77 1.16 2.6 1.81.83.66 1.59 1.42 2.11 2.34.45.81.69 1.72.69 2.65 0 .52-.07 1.04-.23 1.56-.45 1.43-1.28 2.82-2.3 4.04z",
    fill: "url(#fill_foot_right_base)",
    style: {
      fill: "url(#fill_foot_right_base)"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "foot_right_layer_1",
    d: "m213.21 216.12c-.53 1.33-1.28 2.58-2.22 3.67-2.07 2.42-4.93 4.01-7.78 5.44-4.88 2.44-9.92 4.58-14.5 7.52-3.06 1.97-5.9 4.28-8.55 6.78-2.26 2.13-4.41 4.41-6.95 6.21-2.57 1.83-5.53 3.14-8.65 3.6-3.8.56-7.72-.16-11.25-1.67-2.46-1.06-4.84-2.56-6.27-4.83-1.42-2.26-1.75-5.02-1.75-7.69-.02-4.71.87-9.37 1.71-14 .7-3.85 1.36-7.71 1.78-11.6.76-7.08.73-14.22.25-21.32-.08-1.19-.17-2.39.01-3.57s.67-2.35 1.57-3.13c.85-.73 1.99-1.05 3.11-1.1 1.11-.06 2.22.12 3.33.28 2.61.38 5.23.67 7.78 1.33 1.61.42 3.18.98 4.78 1.4 2.68.72 5.49 1.06 8.24.74 2.97-.34 5.85-1.44 8.83-1.37 1.23.03 2.44.26 3.61.62 1.19.37 2.37.9 3.25 1.78.66.67 1.11 1.51 1.48 2.38.53 1.29.89 2.67.91 4.07.03 1.46-.28 2.92-.09 4.37.16 1.17.66 2.28 1.3 3.28.63 1 1.4 1.91 2.17 2.81 1.48 1.75 2.96 3.53 4.82 4.87 2.11 1.53 4.62 2.43 6.8 3.85.65.43 1.28.91 1.74 1.54.78 1.06.98 2.5.54 3.74z",
    clipPath: "url(#clip_foot_right)",
    fill: "#cd8907",
    filter: "url(#blur_foot_right_layer_1)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "foot_right_layer_2",
    d: "m212.91 214.61c-.6 1.35-1.37 2.6-2.28 3.71-2.12 2.58-4.99 4.35-8 5.49-4.97 1.88-10.39 2.13-15.26 4.27-2.97 1.3-5.65 3.26-8.36 5.12-2.18 1.49-4.42 2.94-6.82 3.98-2.72 1.19-5.6 1.85-8.5 2.32-1.84.29-3.71.51-5.57.41s-3.72-.54-5.37-1.49c-1.24-.72-2.36-1.75-3.03-3.1-.73-1.49-.86-3.24-.85-4.94.05-4.5 1.02-8.96.99-13.47-.03-3.93-.81-7.8-1.03-11.72-.43-7.54 1.19-15.2-.24-22.59-.22-1.19-.53-2.37-.52-3.58.01-.6.1-1.21.31-1.77.22-.55.56-1.06 1.01-1.42.39-.29.84-.47 1.31-.56.46-.08.94-.06 1.41.01.93.15 1.82.51 2.73.78 2.6.78 5.35.76 8 1.35 1.66.36 3.26.97 4.91 1.41 2.75.76 5.63 1.08 8.46.75 3.04-.36 6.01-1.46 9.07-1.38 1.26.03 2.5.26 3.71.62s2.42.87 3.34 1.8c.65.67 1.13 1.52 1.51 2.4.57 1.29.96 2.69.95 4.11-.01.74-.12 1.47-.19 2.21-.06.74-.08 1.49.09 2.2.18.72.55 1.37.97 1.96s.9 1.12 1.34 1.7c1.22 1.61 2.1 3.49 3.05 5.3s2.02 3.6 3.53 4.91c2.05 1.77 4.7 2.48 6.99 3.89.67.41 1.31.89 1.78 1.55.38.52.63 1.15.73 1.81.09.65.03 1.34-.17 1.96z",
    clipPath: "url(#clip_foot_right)",
    fill: "#f5c021",
    filter: "url(#blur_foot_right_layer_2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "foot_right_glare",
    d: "m148.08 181.58c2.82-.76 5.22 1.38 7.27 2.99 1.32 1.13 3.24.85 4.86.9 2.69-.09 5.36.45 8.05.12 5.3-.45 10.49-1.75 15.81-1.97 2.54-.16 5.4-.31 7.59 1.17.89.62 2.2 3.23 3.07 2.25-.36-2.74-2.39-5.39-5.11-6.12-2.14-.34-4.3.25-6.46.06-6.39-.15-12.75-1.34-19.16-1-4.46.04-8.91-.17-13.37-.34-1.75-.36-2.37 1.19-3.32 1.79.25.19.34.25.77.15z",
    clipPath: "url(#clip_foot_right)",
    fill: "url(#fill_foot_right_glare)",
    filter: "url(#blur_foot_right_glare)",
    style: {
      fill: "url(#fill_foot_right_glare)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "wing_tip_right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wing_tip_right_shadow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "wing_tip_right_shadow_lower",
    d: "m185.49 187.61c-.48-.95-1.36-1.66-2.35-2.07-.98-.41-2.06-.55-3.13-.54-2.13.02-4.25.57-6.38.39-1.79-.16-3.49-.83-5.24-1.26-1.81-.44-3.73-.61-5.52-.12-1.92.52-3.61 1.81-4.67 3.49-.94 1.48-1.38 3.23-1.52 4.98s.01 3.5.19 5.25c.12 1.26.27 2.52.57 3.75.31 1.23.78 2.43 1.52 3.46 1.07 1.48 2.66 2.54 4.37 3.17 2.8 1.03 5.98.98 8.73-.15 4.88-2.12 9.01-5.92 11.52-10.6.91-1.68 1.61-3.47 2.06-5.31.18-.74.32-1.49.32-2.25.01-.75-.12-1.52-.47-2.19z",
    clipPath: "url(#clip_foot_right)",
    fill: "url(#fill_wing_tip_right_shadow_lower)",
    filter: "url(#blur_wing_tip_right_shadow_lower)",
    opacity: 0.35,
    style: {
      fill: "url(#fill_wing_tip_right_shadow_lower)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "wing_tip_right_shadow_upper",
    d: "m185.49 184.89c-.48-.69-1.36-1.2-2.35-1.5-.98-.3-2.06-.39-3.13-.39-2.13.02-4.25.42-6.38.28-1.79-.11-3.49-.6-5.24-.9-1.81-.32-3.73-.45-5.52-.09-1.92.37-3.61 1.3-4.67 2.52-.94 1.07-1.38 2.34-1.52 3.6s.01 2.53.19 3.79c.12.91.27 1.83.57 2.72.31.89.78 1.76 1.52 2.5 1.07 1.07 2.66 1.83 4.37 2.29 2.8.75 5.98.71 8.73-.11 4.88-1.53 9.01-4.28 11.52-7.66.91-1.22 1.61-2.51 2.06-3.84.18-.54.32-1.08.32-1.62.01-.55-.12-1.11-.47-1.59z",
    clipPath: "url(#clip_foot_right)",
    fill: "url(#fill_wing_tip_right_shadow_upper)",
    filter: "url(#blur_wing_tip_right_shadow_upper)",
    opacity: 0.35,
    style: {
      fill: "url(#fill_wing_tip_right_shadow_upper)"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "wing_tip_right_base",
    d: "m189.55 178.72c-.35-.95-.97-1.79-1.72-2.47s-1.64-1.2-2.57-1.6c-1.86-.79-3.89-1.09-5.89-1.46-1.87-.35-3.74-.78-5.62-1.1-1.96-.33-3.98-.55-5.92-.11-1.69.38-3.26 1.26-4.54 2.43s-2.28 2.63-3 4.21c-1.27 2.79-1.67 5.92-1.43 8.97.18 2.27.76 4.61 2.25 6.32 1.21 1.39 2.92 2.26 4.68 2.78 3.04.9 6.35.85 9.36-.13 4.97-1.67 9.37-4.98 12.35-9.29.98-1.43 1.82-2.98 2.2-4.66.29-1.28.3-2.66-.15-3.89z",
    fill: "#020204"
  })), /*#__PURE__*/React.createElement("g", {
    id: "wing_tip_right_glare"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", {
    id: "defs104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_wing_tip_right_glare",
    d: "m168.89 171.07c-.47.03-.93.08-1.4.17-2.99.53-5.73 2.42-7.27 5.03-1.09 1.85-1.58 4.03-1.43 6.17.07-1.5.46-2.97 1.19-4.28 1.23-2.23 3.47-3.91 5.98-4.37 1.54-.28 3.13-.11 4.68.08 1.5.19 3 .39 4.47.7 2.28.5 4.53 1.26 6.44 2.59.44.31.86.66 1.21 1.08.35.41.62.89.73 1.42.15.78-.07 1.6-.46 2.29-.39.7-.92 1.3-1.48 1.86-.46.46-.94.89-1.43 1.32 2.21-.43 4.44-1.03 6.28-2.31.77-.55 1.48-1.2 1.94-2.02.46-.83.65-1.83.43-2.75-.16-.62-.5-1.19-.92-1.67s-.93-.87-1.45-1.24c-2.31-1.62-5.01-2.65-7.81-2.99-1.8-.33-3.61-.61-5.42-.83-1.41-.18-2.86-.33-4.28-.25z"
  }))), /*#__PURE__*/React.createElement("use", {
    id: "wing_tip_right_glare_1",
    clipPath: "url(#clip_wing_tip_right)",
    fill: "url(#fill_wing_tip_right_glare_1)",
    filter: "url(#blur_wing_tip_right_glare)",
    style: {
      fill: "url(#fill_wing_tip_right_glare_1)"
    },
    href: "#path_wing_tip_right_glare",
    xlinkHref: "#path_wing_tip_right_glare"
  }), /*#__PURE__*/React.createElement("use", {
    id: "wing_tip_right_glare_2",
    clipPath: "url(#clip_wing_tip_right)",
    fill: "url(#fill_wing_tip_right_glare_2)",
    filter: "url(#blur_wing_tip_right_glare)",
    style: {
      fill: "url(#fill_wing_tip_right_glare_2)"
    },
    href: "#path_wing_tip_right_glare",
    xlinkHref: "#path_wing_tip_right_glare"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "face"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eyes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye_left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eyeball_left",
    d: "m84.45 38.28c-1.53.08-3 .79-4.12 1.84-1.13 1.05-1.92 2.43-2.41 3.88-.97 2.92-.75 6.08-.53 9.15.2 2.77.41 5.6 1.45 8.18.52 1.3 1.25 2.51 2.22 3.51.97.99 2.2 1.76 3.55 2.09 1.26.32 2.62.26 3.86-.13 1.25-.4 2.38-1.11 3.32-2.02 1.36-1.33 2.27-3.07 2.8-4.9s.68-3.75.65-5.66c-.04-2.38-.35-4.77-1.09-7.03-.75-2.26-1.94-4.4-3.6-6.11-.8-.83-1.72-1.55-2.75-2.06-1.04-.51-2.2-.8-3.35-.74z",
    fill: "url(#fill_eyeball_left)",
    style: {
      fill: "url(#fill_eyeball_left)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "pupil_left"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "pupil_left_base",
    d: "m80.75 50.99c-.32 1.94-.33 3.97.33 5.81.44 1.22 1.17 2.33 2.05 3.28.57.62 1.23 1.18 1.99 1.55.77.37 1.65.52 2.48.32.76-.19 1.42-.68 1.91-1.29s.82-1.34 1.05-2.09c.69-2.21.58-4.62-.11-6.83-.49-1.61-1.32-3.16-2.6-4.24-.62-.52-1.34-.93-2.12-1.11-.78-.19-1.63-.14-2.36.19-.81.37-1.44 1.07-1.85 1.86s-.62 1.67-.77 2.55z",
    fill: "#020204"
  })), /*#__PURE__*/React.createElement("path", {
    id: "pupil_left_glare",
    d: "m84.84 49.59c.21.55.91.75 1.3 1.19.37.42.76.87.97 1.4.39 1.01-.39 2.51.43 3.23.25.22.77.23 1.02 0 .99-.9.77-2.71.38-3.99-.36-1.15-1.23-2.25-2.31-2.8-.5-.26-1.25-.47-1.68-.11-.27.24-.24.74-.11 1.08z",
    clipPath: "url(#clip_pupil_left)",
    fill: "url(#fill_pupil_left_glare)",
    filter: "url(#blur_pupil_left_glare)",
    style: {
      fill: "url(#fill_pupil_left_glare)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "eyelid_left",
    d: "m81.14 44.46c2.32-1.38 5.13-1.7 7.82-1.45 2.68.26 5.27 1.04 7.87 1.75 1.91.52 3.84 1 5.63 1.84 1.78.84 3.44 2.08 4.43 3.8.16.27.29.56.46.83s.37.52.62.71.57.32.88.3c.16-.01.32-.05.45-.13.14-.08.26-.2.33-.34.08-.16.11-.35.1-.53s-.05-.36-.1-.54c-.65-2.37-2.19-4.38-3.35-6.55-.7-1.3-1.28-2.66-1.98-3.96-2.43-4.45-6.42-7.94-10.95-10.21s-9.59-3.36-14.65-3.65c-5.86-.35-11.73.35-17.51 1.37-2.51.44-5.06.96-7.27 2.21-1.11.62-2.13 1.42-2.92 2.42-.8.99-1.36 2.18-1.55 3.44-.17 1.22.01 2.47.44 3.62.42 1.15 1.08 2.2 1.86 3.15 1.54 1.91 3.53 3.39 5.36 5.03 1.83 1.63 3.52 3.44 5.57 4.79 1.02.68 2.13 1.24 3.31 1.57s2.44.42 3.64.17c1.24-.25 2.4-.86 3.41-1.64 1.01-.77 1.88-1.7 2.71-2.66 1.66-1.93 3.21-4.04 5.39-5.34z",
    clipPath: "url(#clip_eye_left)",
    fill: "url(#fill_eyelid_left)",
    style: {
      fill: "url(#fill_eyelid_left)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "eyebrow_left",
    d: "m90.77 36.57c2.16 2.02 3.76 4.52 4.85 7.16-.48-2.91-1.23-5.26-3.13-7.16-1.16-1.09-2.49-2.05-3.98-2.72-1.32-.59-2.77-.96-3.61-.97-.83-.02-1.03 0-1.2.01-.18.01-.31.01.23.08.54.06 1.75.39 3.05.97s2.62 1.54 3.79 2.63z",
    fill: "url(#fill_eyebrow_left)",
    filter: "url(#blur_eyebrow_left)",
    style: {
      fill: "url(#fill_eyebrow_left)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "eye_right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eyeball_right",
    d: "m111.61 38.28c-2.39 1.65-4.4 3.94-5.38 6.68-1.24 3.45-.77 7.31.43 10.77 1.22 3.55 3.27 6.93 6.36 9.06 1.54 1.07 3.33 1.8 5.19 2.02 1.87.22 3.8-.09 5.47-.95 2.02-1.06 3.57-2.91 4.53-4.98.96-2.08 1.37-4.37 1.5-6.66.16-2.9-.12-5.86-1.08-8.61-1.04-2.99-2.92-5.75-5.58-7.47-1.32-.86-2.83-1.45-4.4-1.67s-3.19-.05-4.67.52c-.84.33-1.62.78-2.37 1.29z",
    fill: "url(#fill_eyeball_right)",
    style: {
      fill: "url(#fill_eyeball_right)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "pupil_right"
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "pupil_right_base",
    d: "m117.14 45.52c-.9.06-1.78.37-2.55.85-.76.48-1.41 1.13-1.92 1.88-1.03 1.49-1.48 3.31-1.55 5.12-.05 1.35.1 2.72.55 4s1.2 2.47 2.25 3.33c1.07.89 2.42 1.42 3.81 1.49 1.39.06 2.79-.34 3.93-1.13.91-.63 1.64-1.5 2.16-2.48.52-.97.84-2.05.98-3.15.25-1.93-.03-3.95-.93-5.69-.89-1.74-2.41-3.17-4.24-3.84-.8-.29-1.65-.44-2.49-.38z",
    fill: "#020204"
  })), /*#__PURE__*/React.createElement("path", {
    id: "pupil_right_glare",
    d: "m122.71 53.36c1-1-.71-3.65-2.05-4.74-.97-.78-3.78-1.61-3.66-.75.12.85 1.39 1.95 2.23 2.79 1.05 1.03 3 3.18 3.48 2.7z",
    clipPath: "url(#clip_pupil_right)",
    fill: "url(#fill_pupil_right_glare)",
    filter: "url(#blur_pupil_right_glare)",
    style: {
      fill: "url(#fill_pupil_right_glare)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "eyelid_right",
    d: "m102.56 47.01c2.06-1.71 4.45-3.01 7-3.8 5.25-1.62 11.2-.98 15.84 1.97 1.6 1.01 3.03 2.27 4.52 3.45 1.48 1.17 3.06 2.27 4.85 2.9.97.34 2 .54 3.02.43.92-.09 1.81-.44 2.57-.96.76-.53 1.4-1.23 1.88-2.02.96-1.58 1.27-3.5 1.1-5.34-.33-3.69-2.41-6.94-4.15-10.21-.55-1.02-1.07-2.06-1.73-3.01-2.01-2.93-5.23-4.86-8.6-5.99s-6.93-1.54-10.46-1.98c-1.58-.2-3.17-.41-4.74-.22-1.81.22-3.51.95-5.28 1.4-.84.22-1.69.37-2.52.61s-1.65.57-2.33 1.11c-.98.79-1.6 1.98-1.87 3.21-.27 1.24-.21 2.52-.01 3.77.39 2.5 1.33 4.93 1.24 7.46-.06 1.73-.61 3.44-.54 5.17.02.51.12 1.55.21 2.05z",
    clipPath: "url(#clip_eye_right)",
    fill: "url(#fill_eyelid_right)",
    style: {
      fill: "url(#fill_eyelid_right)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "eyebrow_right",
    d: "m119.93 31.18c-.41.52-.78 1.08-1.07 1.7 1.85.4 3.61 1.16 5.19 2.21 3.06 2.03 5.38 4.99 7.01 8.29.38-.42.72-.87 1.02-1.37-1.64-3.44-4-6.55-7.16-8.65-1.52-1-3.21-1.77-4.99-2.18z",
    fill: "url(#fill_eyebrow_right)",
    filter: "url(#blur_eyebrow_right)",
    style: {
      fill: "url(#fill_eyebrow_right)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "beak"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "beak_shadow",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "beak_shadow_lower",
    d: "m81.12 89.33c1.47 4.26 4.42 7.89 7.92 10.72 1.16.95 2.39 1.82 3.76 2.43 1.36.62 2.87.97 4.36.84 1.46-.12 2.85-.7 4.13-1.42s2.46-1.59 3.7-2.37c2.12-1.35 4.39-2.44 6.6-3.64 2.65-1.45 5.23-3.1 7.46-5.14 1.03-.93 1.98-1.95 3.11-2.75 1.13-.81 2.49-1.39 3.87-1.29 1.04.07 2.01.51 3.03.73.51.11 1.03.16 1.55.08.51-.08 1.01-.29 1.37-.67.44-.46.64-1.12.61-1.76-.02-.63-.24-1.25-.54-1.81-.59-1.13-1.49-2.1-1.89-3.31-.36-1.08-.29-2.24-.26-3.37.03-1.14.01-2.32-.51-3.33-.4-.76-1.07-1.37-1.83-1.77-.76-.41-1.62-.62-2.48-.7-1.72-.16-3.44.18-5.17.27-2.28.13-4.58-.15-6.87-.02-2.85.18-5.65 1-8.51 1.01-3.26.01-6.52-1.06-9.74-.55-1.39.22-2.71.72-4.03 1.16-1.33.45-2.7.84-4.1.82-1.59-.03-3.13-.58-4.72-.69-.79-.06-1.6 0-2.35.28-.74.28-1.41.79-1.78 1.5-.21.4-.31.86-.33 1.31-.02.46.04.91.15 1.36.22.88.63 1.71.96 2.55 1.2 3.07 1.46 6.42 2.53 9.53z",
    clipPath: "url(#clip_body)",
    fillOpacity: 0.25882,
    filter: "url(#blur_beak_shadow_lower)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "beak_shadow_upper",
    d: "m77.03 77.2c2.85 1.76 5.41 3.93 7.56 6.39 1.99 2.29 3.68 4.89 6.29 6.58 1.83 1.2 4.04 1.87 6.28 2.08 2.63.24 5.29-.15 7.83-.84 2.35-.63 4.62-1.53 6.7-2.71 3.97-2.25 7.28-5.55 11.65-7.03.95-.33 1.94-.56 2.86-.96.92-.39 1.79-.99 2.23-1.83.42-.82.4-1.75.54-2.64.15-.96.48-1.88.66-2.83s.2-1.96-.24-2.83c-.37-.72-1.04-1.29-1.81-1.66-.77-.36-1.64-.52-2.51-.56-1.72-.08-3.43.33-5.16.47-2.28.19-4.58-.08-6.87-.01-2.85.08-5.66.67-8.51.8-3.25.14-6.49-.34-9.74-.44-1.41-.05-2.83-.03-4.21.2-1.39.22-2.75.65-3.92 1.37-1.14.69-2.07 1.64-3.11 2.45-.52.41-1.08.78-1.68 1.07-.61.28-1.28.48-1.96.51-.35.01-.71-.01-1.05.04-.59.08-1.13.39-1.47.83-.34.45-.47 1.02-.36 1.55z",
    clipPath: "url(#clip_body)",
    filter: "url(#blur_beak_shadow_upper)",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("path", {
    id: "beak_base",
    d: "m91.66 58.53c1.53-1.71 2.57-3.8 4.03-5.56.73-.88 1.58-1.69 2.57-2.26s2.15-.89 3.29-.79c1.27.11 2.46.74 3.39 1.61s1.62 1.97 2.17 3.12c.53 1.11.95 2.28 1.71 3.24.81 1.02 1.94 1.71 2.97 2.52.51.4 1.01.83 1.41 1.34.41.51.72 1.1.86 1.74.13.65.06 1.33-.16 1.95-.23.62-.61 1.18-1.09 1.64-.95.92-2.25 1.42-3.56 1.6-2.62.37-5.27-.41-7.92-.34-2.67.08-5.29 1.02-7.97.93-1.33-.05-2.69-.38-3.79-1.14-.55-.39-1.03-.88-1.38-1.45-.34-.57-.55-1.23-.58-1.9-.02-.64.13-1.28.39-1.86.25-.59.61-1.12 1.01-1.62.81-.99 1.8-1.81 2.65-2.77z",
    fill: "url(#fill_beak_base)",
    style: {
      fill: "url(#fill_beak_base)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "mandible_lower"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mandible_lower_base",
    d: "m77.14 75.05c.06.26.15.5.28.73.23.38.57.69.93.95.36.27.75.49 1.13.72 2.01 1.27 3.65 3.04 5.11 4.92 1.95 2.52 3.68 5.31 6.29 7.14 1.84 1.3 4.04 2.03 6.28 2.26 2.63.26 5.29-.16 7.83-.91 2.35-.69 4.62-1.66 6.7-2.95 3.97-2.44 7.28-6.02 11.65-7.63.95-.35 1.94-.6 2.86-1.03.92-.44 1.79-1.08 2.23-2 .42-.88.4-1.9.54-2.87.15-1.03.48-2.03.66-3.06s.2-2.13-.24-3.08c-.37-.78-1.04-1.4-1.81-1.79-.77-.4-1.64-.58-2.51-.62-1.72-.08-3.43.36-5.16.52-2.28.21-4.58-.09-6.87-.02-2.85.09-5.66.73-8.51.87-3.25.15-6.49-.35-9.74-.48-1.41-.06-2.83-.04-4.22.2-1.39.23-2.75.71-3.91 1.51-1.13.78-2.03 1.84-3.07 2.74-.52.45-1.08.86-1.7 1.16-.61.3-1.29.49-1.98.47-.35-.01-.72-.06-1.05.04-.21.07-.4.2-.56.35-.16.16-.29.34-.41.52-.29.42-.54.87-.75 1.34z",
    fill: "url(#fill_mandible_lower_base)",
    style: {
      fill: "url(#fill_mandible_lower_base)"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "mandible_lower_glare",
    d: "m89.9 78.56c-.33 1.37-.13 2.87.56 4.11.68 1.24 1.84 2.2 3.19 2.65 1.7.57 3.62.29 5.21-.54.93-.48 1.77-1.16 2.3-2.06.27-.44.46-.94.53-1.46.06-.51.02-1.05-.16-1.54-.2-.53-.56-1-.99-1.37-.44-.37-.95-.64-1.5-.82-1.08-.36-2.77-.66-3.91-.68-2.02-.04-4.9.34-5.23 1.71z",
    clipPath: "url(#clip_mandible_lower)",
    fill: "#d9b30d",
    filter: "url(#blur_mandible_lower_glare)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "mandible_upper"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "mandible_upper_shadow",
    d: "m84.31 67.86c-1.16.68-2.27 1.43-3.36 2.2-.57.41-1.15.84-1.45 1.47-.21.44-.26.94-.27 1.43 0 .5.03.99-.04 1.48-.04.33-.13.66-.14.99-.01.17 0 .34.04.5.05.16.13.32.24.44.15.16.35.26.56.32s.42.09.64.14c1.01.24 1.89.86 2.66 1.56.77.69 1.47 1.48 2.28 2.13 2.18 1.78 5.07 2.52 7.89 2.56 2.82.05 5.61-.54 8.36-1.16 2.16-.49 4.32-.99 6.39-1.76 3.2-1.18 6.16-2.96 8.72-5.19 1.17-1.01 2.26-2.12 3.57-2.94 1.15-.73 2.44-1.21 3.62-1.9.11-.06.21-.13.3-.2.1-.08.18-.18.24-.28.09-.19.09-.42.03-.62s-.18-.38-.31-.55c-.15-.18-.31-.34-.49-.5-1.23-1.05-2.89-1.43-4.51-1.56-1.61-.12-3.24-.03-4.83-.3-1.5-.25-2.92-.81-4.37-1.27-1.52-.49-3.07-.87-4.64-1.13-3.71-.61-7.52-.49-11.19.27-3.49.73-6.87 2.05-9.94 3.87z",
    clipPath: "url(#clip_mandible_lower)",
    fill: "#604405",
    filter: "url(#blur_mandible_upper_shadow)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "mandible_upper_base",
    d: "m83.94 63.95c-1.66 1.12-3.16 2.49-4.43 4.04-.72.89-1.38 1.86-1.74 2.94-.29.86-.39 1.76-.57 2.65-.07.33-.15.66-.14 1 0 .16.02.33.07.5.05.16.14.31.25.43.2.2.47.31.74.37.28.05.56.06.84.09 1.25.15 2.4.75 3.44 1.47 1.04.71 2 1.55 3.07 2.22 2.35 1.49 5.16 2.15 7.95 2.26 2.78.11 5.56-.31 8.3-.86 2.17-.43 4.33-.95 6.39-1.76 3.16-1.25 6.01-3.16 8.72-5.19 1.24-.92 2.46-1.87 3.57-2.94.37-.37.74-.74 1.14-1.08.4-.33.85-.62 1.35-.78.76-.24 1.58-.17 2.37-.04.59.1 1.18.23 1.78.21.3-.02.6-.07.88-.18s.54-.28.73-.52c.25-.3.38-.7.38-1.09 0-.4-.12-.79-.32-1.13-.4-.68-1.09-1.14-1.81-1.46-.99-.44-2.06-.65-3.11-.91-3.23-.78-6.37-1.93-9.34-3.41-1.48-.73-2.92-1.54-4.37-2.32-1.5-.8-3.02-1.57-4.64-2.07-3.64-1.1-7.6-.74-11.19.51-3.98 1.38-7.58 3.84-10.31 7.05z",
    fill: "url(#fill_mandible_upper_base)",
    style: {
      fill: "url(#fill_mandible_upper_base)"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "mandible_upper_glare",
    d: "m109.45 64.75c-.2-.24-.48-.42-.78-.51s-.62-.09-.93-.04c-.62.11-1.18.44-1.7.8-1.47 1.01-2.77 2.26-3.91 3.64-1.5 1.83-2.74 3.94-3.16 6.27-.07.39-.11.8-.07 1.19.05.4.2.79.49 1.07.24.25.58.4.92.45.35.05.71 0 1.04-.11.66-.22 1.21-.69 1.74-1.15 2.87-2.58 5.47-5.66 6.51-9.38.1-.37.19-.75.19-1.14s-.1-.78-.34-1.09z",
    clipPath: "url(#clip_mandible_upper)",
    fill: "#f6da4a",
    filter: "url(#blur_mandible_upper_glare)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "naris_left",
    d: "m92.72 59.06c-.77-.25-2.03 1.1-1.62 1.79.11.19.46.43.7.3.35-.19.64-.89 1.02-1.16.25-.18.2-.84-.1-.93z",
    fill: "url(#fill_naris_left)",
    filter: "url(#blur_naris_left)",
    opacity: 0.8,
    style: {
      fill: "url(#fill_naris_left)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "naris_right",
    d: "m102.56 59.42c.2.64 1.23.53 1.83.84.52.27.94.86 1.53.88.56.01 1.44-.2 1.51-.76.09-.73-.98-1.2-1.67-1.47-.89-.34-2.03-.52-2.86-.06-.19.11-.4.36-.34.57z",
    fill: "url(#fill_naris_right)",
    filter: "url(#blur_naris_right)",
    opacity: 0.8,
    style: {
      fill: "url(#fill_naris_right)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "beak_corner",
    d: "m129.27 69.15a2.42 3.1 16.94 01-2.81 3.04 2.42 3.1 16.94 01-2.12-3.04 2.42 3.1 16.94 012.81-3.05 2.42 3.1 16.94 012.12 3.05z",
    clipPath: "url(#clip_beak)",
    fill: "url(#fill_beak_corner)",
    filter: "url(#blur_beak_corner)",
    style: {
      fill: "url(#fill_beak_corner)"
    }
  })))), /*#__PURE__*/React.createElement("ellipse", {
    id: "path105",
    cx: 255.08,
    cy: 226.62,
    rx: 3.3179,
    ry: 5.2139,
    style: {
      fillOpacity: 0.98829,
      fill: "#f70000",
      opacity: 0.86526,
      strokeLinejoin: "bevel",
      strokeWidth: 0.397,
      stroke: "#7e7e7e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "text105",
    d: "m26.501 197.58-12.924 3.2583-.41072-1.629 11.476-2.8932-1.4238-5.6473 1.448-.36508zm-18.518-27.271q-.02629-.3724.21468-.67011.22103-.31501.76102-.35313.52137-.0368.80309.24272.2804.2609.30669.63331.02892.40965-.21205.70736-.24097.2977-.76234.33451-.53999.0381-.80177-.2241-.2804-.26091-.30932-.67056zm3.6862-1.0649 9.9805-.70452.11567 1.6386-9.9805.70452zm.54296-28.089q.20221-1.7806 1.1772-2.5904.9564-.81193 2.8853-.59287l6.4731.73512-.18325 1.6136-6.3618-.72248q-2.3926-.27172-2.6454 1.954-.18747 1.6507.66829 2.3866.85576.73594 2.5992.93393l5.1562.58557-.18536 1.6322-9.9414-1.129.14955-1.3169 1.3813-.0874.01053-.0927q-.72423-.5707-.99829-1.466-.2926-.89742-.18518-1.8433zm8.3037-34.424 9.4916 3.1648-.42513 1.275-1.334-.18902-.02362.0708q.59023.70841.67278 1.6411.06485.92676-.24219 1.8476-.57274 1.7177-1.6766 2.3138-1.1216.59019-2.9279-.0121l-6.2156-2.0725.5255-1.576 6.1093 2.0371q2.2667.75578 2.9693-1.3515.5255-1.576-.15915-2.4734-.67875-.91501-2.3433-1.47l-4.9406-1.6474zm15.17-20.967-5.9633.53179.93701-1.6145 4.5543-.3352-1.9775-4.1046.92764-1.5983 2.4964 5.4417 6.2508-.5808-.93701 1.6145-4.823.35192 2.0682 4.3946-.92764 1.5983zm21.763-21.129q-.87697.9937-1.9745 1.4193-1.0852.41156-2.3342.10597-1.2366-.31959-2.5662-1.493-1.3856-1.2228-1.8457-2.4505-.46013-1.2277-.17431-2.3696.29817-1.156 1.1875-2.1636.50642-.57382 1.1017-.9945.58133-.43302 1.0457-.6207l.68819 1.2796q-.4224.22473-.92962.57378-.50722.34905-.85307.74093-1.9516 2.2113.88956 4.7187 1.3576 1.1981 2.5547 1.3086 1.1955.08411 2.1342-.97957.54348-.61581.82512-1.1888.294-.58702.4579-1.1395l1.0917.96344q-.13756.55081-.44719 1.0991-.28329.54668-.85147 1.1905zm13.638-26.484q1.4618-1.0998 2.6455-.98581t2.2385 1.5161l4.0961 5.4446-.95467.71822-1.1065-.94289-.05967.04489q-.0283 1.0491-.37439 1.8-.33117.7397-1.3455 1.5028-1.0889.81922-2.2314.79106-1.1537-.04308-2.0739-1.2663-.89778-1.1933-.44058-2.5418.44597-1.3633 2.3552-2.8931l1.3238-1.066-.35911-.47733q-.75189-.99942-1.4763-1.0618-.72436-.06239-1.5149.53239-.6265.47133-1.0474 1.0917-.43217.60544-.74486 1.2144l-1.1434-.6815q.30886-.6762.87897-1.4088.55889-.7475 1.3346-1.3311zm3.5974 3.9744q-1.4468 1.1819-1.7143 2.0372-.25261.84411.31972 1.6049.505.67125 1.1434.6815.65333-.000972 1.2948-.48353 1.0143-.76311 1.2704-1.82.24481-1.0718-.63053-2.2353l-.53867-.716zm24.086-18.825-2.269 1.0964 3.8008 7.8659-1.4791.71468-3.8008-7.8659-1.5799.76341-.33298-.6891 1.3363-1.2676-.25176-.52103q-.84462-1.748-.43694-2.8779.39956-1.1467 1.7778-1.8127.53784-.25988 1.0236-.37019.49441-.13524.8706-.17189l.1738 1.3465q-.30953.0459-.70309.13242-.39356.08651-.76333.26518-.73953.35734-.86565 1.0402-.11744.65796.39421 1.7168l.28425.58826 2.269-1.0964zm23.807-9.9667q1.2465-.32427 2.2727-.01259 1.0443.30698 1.7724 1.1784.74154.84864 1.0846 2.1674l.24907.95747-6.63 1.7248q.46379 1.6346 1.4842 2.2949 1.0338.63759 2.4791.26162.92134-.23968 1.5836-.58555.67562-.36864 1.3498-.8912l.36187 1.391q-.65609.51786-1.3411.85037-.68032.35057-1.6739.60905-1.373.35717-2.5845.07442-1.1935-.28745-2.0763-1.2344-.86947-.96967-1.2877-2.5775-.41357-1.5898-.18575-2.8642.24589-1.2791 1.0436-2.1424.81575-.868 2.0984-1.2017zm.32031 1.3054q-1.1381.29608-1.6139 1.2106-.46237.8918-.25046 2.2254l4.9319-1.283q-.33764-1.2237-1.095-1.8368-.76211-.63112-1.9725-.31625zm81.185 7.7511q-.50572 1.6997-2.0224 2.2806-1.5167.58094-3.61-.04189-1.0735-.3194-1.938-.75192-.86456-.43252-1.3877-.89978l.45781-1.5387q.55892.47791 1.438.99263.89694.52005 1.9168.82348 1.4313.42587 2.312.08417.89858-.33638 1.1807-1.2846.18632-.6262.0457-1.1355-.14061-.50925-.69613-1.064-.53231-.56736-1.5728-1.3249-1.4525-1.0748-2.0378-2.1838-.56749-1.1037-.12565-2.5887.30343-1.0198 1.0352-1.5811.73711-.57918 1.7667-.7013 1.0475-.1168 2.2462.23987 1.0556.31408 1.8737.77173.81813.45765 1.438.99264l-.91086 1.2286q-.57681-.48323-1.3055-.91426-.71078-.42571-1.5517-.67591-1.1987-.35667-1.9614-.01881-.75737.31997-1.0076 1.1609-.19165.6441-.051 1.1533.14061.50925.64778 1.0302.50717.52093 1.4278 1.2233 1.0047.74688 1.6303 1.4589.64882.69941.84547 1.4785.21454.78442-.0836 1.7864zm21.617 11.939q.33113.17243.70468.3038.38218.11482.6319.16067l-.57763 1.1093q-.29214-.0048-.7571-.16273-.47357-.14137-.87093-.34828-.69538-.3621-1.1707-.90425-.45016-.55009-.50404-1.3358-.0539-.7857.50651-1.8619l2.6898-5.1656-1.2583-.65522.3621-.69537 1.5766.08436 1.5623-1.5857.86094.44831-1.0604 2.0365 2.5663 1.3363-.58625 1.1258-2.5663-1.3363-2.6726 5.1325q-.42245.81127-.24856 1.4069.19907.58771.81166.9067zm30.544 10.029-6.2393 7.8216-1.0507-.83812.63677-1.1874-.0584-.04656q-.86831.31024-1.7724.06662-.89243-.2582-1.6512-.86351-1.4155-1.1291-1.5951-2.3708-.16793-1.2562 1.0194-2.7447l4.0858-5.122 1.2987 1.036-4.016 5.0344q-1.49 1.8679.24653 3.2531 1.2987 1.036 2.3769.70215 1.0928-.32221 2.187-1.6939l3.2477-4.0713zm12.061 24.696q.24227.28405.53926.54596.3112.2498.52548.38597l-.95155.81161q-.26901-.11404-.64077-.43484-.38597-.30869-.6767-.64955-.50877-.5965-.74602-1.2774-.21095-.67879.0338-1.4273.24478-.74854 1.1679-1.5359l4.4311-3.7794-.92063-1.0794.5965-.50877 1.4298.6696 2.043-.88387.62991.73852-1.7469 1.49 1.8776 2.2014-.96576.82372-1.8776-2.2014-4.4027 3.7552q-.69592.59357-.75816 1.2109-.0359.61947.41228 1.145zm14.411 20.672q.1897.32155.43711.63072.26348.29969.4511.47076l-1.0772.63547q-.24533-.15869-.55624-.53877-.32699-.37059-.55462-.75645-.39836-.67526-.51472-1.3868-.0908-.70498.27933-1.4001.37013-.69515 1.4152-1.3117l5.0162-2.9592-.72084-1.2219.67526-.39836 1.293.906 2.1648-.51854.49321.83603-1.9775 1.1666 1.4701 2.492-1.0933.64496-1.4701-2.492-4.984 2.9402q-.7878.46475-.95551 1.0622-.14215.60401.20878 1.1989zm19.218 20.006q.33383.93131.24693 1.7953-.0806.88156-.6121 1.667l.0315.0879 1.3232-.23633.4409 1.23-9.5767 3.4327q-2.0208.72434-3.4116.0529-1.3845-.65385-2.1592-2.8152-.74323-2.0735-.61818-3.6055l1.4233-.51018q-.24043 1.6527.50909 3.7438.4346 1.2125 1.4007 1.6395.95482.45094 2.1849.01l.36901-.13227q.21087-.0756.60375-.19658.41045-.12729.5749-.16641l-.0252-.0703q-1.7635-.4387-2.4689-2.4068-.65505-1.8275.25609-3.324.91744-1.479 3.2194-2.3041 2.2492-.80622 3.9324-.25943 1.7071.55806 2.3558 2.368zm-1.2247.67696q-.422-1.1773-1.6039-1.4874-1.1644-.31634-2.904.30722-1.7396.62355-2.4442 1.59-.6807.97768-.2398 2.2077.51018 1.4233 1.4988 1.8027 1.0062.37302 2.7107-.23794l.36901-.13226q1.9329-.69284 2.5194-1.6566.60411-.97007.0939-2.3934zm8.9667 30.382q.2599 1.8108-.40998 2.7932t-2.4068 1.2318l-6.7442.96799-.16973-1.1826 1.3592-.51567-.0106-.0739q-.90582-.53002-1.3973-1.1949-.48881-.64645-.66914-1.9029-.1936-1.3488.38124-2.3365.59332-.99035 2.1085-1.2078 1.4782-.21216 2.4398.83787.98008 1.0474 1.4014 3.4573l.29677 1.6735.59127-.0849q1.238-.17768 1.6415-.78248.4035-.60479.26294-1.5841-.11138-.77605-.45236-1.4437-.32251-.67031-.70566-1.2376l1.1479-.67392q.44389.59632.81139 1.4488.38598.84979.52388 1.8106zm-5.2156 1.2389q-.33911-1.8371-.9599-2.4835-.61814-.62788-1.5605-.49263-.83148.11934-1.1479.67392-.31377.57306-.19973 1.3676.18034 1.2565.98334 1.9898.82148.73071 2.2627.52385l.88692-.1273zm6.5044 30.25q-.0131.27969-.0653.59493-.0344.33476-.1017.57453l-1.5007-.27594q.0673-.23978.11859-.53637.0504-.27794.0627-.53899.0359-.76449-.36152-1.4559-.37874-.6905-1.124-1.1366-.72748-.42655-1.7344-.47378l-5.3328-.25011.0769-1.6409 9.9944.46873-.063 1.3425-1.8361.10076-.003.0746q.7977.52328 1.3585 1.3158.56083.79248.51185 1.8367zm-12.733 24.151q-.0832.36395-.11593.75858-.0145.39878.004.65198l-1.2192-.27866q-.0692-.28388-.0338-.77365.0171-.49393.11697-.93067.17468-.76429.57918-1.3612.41853-.57452 1.1651-.82514.74661-.25061 1.9294.0197l5.6776 1.2976.31609-1.383.76429.17468.31666 1.5468 1.9289 1.111-.21627.94626-2.2383-.51157-.64466 2.8206-1.2374-.28282.64466-2.8206-5.6412-1.2893q-.89167-.20379-1.4241.11493-.51836.34108-.67225 1.0144z",
    style: {
      fillOpacity: 0.98829,
      opacity: 0.86526,
      strokeLinejoin: "bevel",
      strokeWidth: 0.7,
      stroke: "#010102",
      whiteSpace: "pre"
    },
    "aria-label": "Linuxcafe  Stuttgart"
  }), /*#__PURE__*/React.createElement("text", {
    id: "text106",
    transform: "translate(53.632 16.164)",
    style: {
      fill: "none",
      fontFamily: "'Liberation Sans'",
      fontSize: "18.667px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      letterSpacing: "18.29px",
      lineHeight: 0,
      opacity: 0.86526,
      shapeInside: "url(#rect106)",
      strokeLinejoin: "bevel",
      strokeWidth: 2,
      stroke: "#001582",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLcLogoOptimiert);
export default __webpack_public_path__ + "static/media/LC-Logo_optimiert.8b77b3e8f3e88bfd12652a1d96efde37.svg";
export { ForwardRef as ReactComponent };